import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcfee2ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { scope: "row" }
const _hoisted_2 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "qty" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "icon sm remove-cart-item-logo",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  id: "icon-close"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.146 11.217a.5.5 0 1 0 .708.708l3.182-3.182 3.181 3.182a.5.5 0 1 0 .708-.708l-3.182-3.18 3.182-3.182a.5.5 0 1 0-.708-.708l-3.18 3.181-3.183-3.182a.5.5 0 0 0-.708.708l3.182 3.182-3.182 3.181z",
  "stroke-width": "0"
}, null, -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "text-right" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("h6", null, _toDisplayString($props.item.product_id), 1 /* TEXT */),
      ($setup.best_max_user_not_achieved)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(_ctx.__("This product may be unsuitable for the number of user defined.")), 1 /* TEXT */),
            _createElementVNode("div", null, _toDisplayString(_ctx.__("Please check the product description.")), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($props.item.estimated_setup_time)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.__("Est. setup time*")) + ": ", 1 /* TEXT */),
            _createElementVNode("span", null, _toDisplayString($props.item.estimated_setup_time) + " " + _toDisplayString(_ctx.__("H")), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["qty-minus", [$setup.item_can_be_updated() ? 'grey-btn' : '']]),
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('minusQty', $props.item)))
        }, [
          ($setup.item_can_be_updated())
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.item_qty) + " " + _toDisplayString(_ctx.__($setup.item_unit)), 1 /* TEXT */),
        _createElementVNode("div", {
          class: _normalizeClass(["qty-plus", [$setup.item_can_be_updated() ? 'grey-btn' : '']]),
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('plusQty', $props.item)))
        }, [
          ($setup.item_can_be_updated())
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+"))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["del", [$setup.item_can_be_removed() ? 'grey-btn' : '']]),
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('removeItem', $props.item)))
        }, [
          ($setup.item_can_be_removed())
            ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", null, _toDisplayString(_ctx.frappe.datetime.obj_to_user($props.item.start_date)), 1 /* TEXT */)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", null, _toDisplayString(_ctx.__($setup.renewal_date)), 1 /* TEXT */)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", {
        class: _normalizeClass($setup.is_free_limit_expired ? 'linethrough' : '')
      }, _toDisplayString(_ctx.__($setup.eval_end_date)), 3 /* TEXT, CLASS */)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", null, _toDisplayString($setup.ioi_format_currency($setup.install_cost || 0.0, $props.item.currency)), 1 /* TEXT */)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", null, _toDisplayString($setup.ioi_format_currency($setup.enduser_price || 0.0, $props.item.currency)), 1 /* TEXT */)
    ]),
    _createElementVNode("td", _hoisted_11, [
      _createElementVNode("span", {
        class: _normalizeClass($setup.is_eval ? 'linethrough' : '')
      }, _toDisplayString($setup.ioi_format_currency($setup.item_total || 0.0, $props.item.currency)), 3 /* TEXT, CLASS */)
    ])
  ]))
}